import { render, staticRenderFns } from "./Clothing.vue?vue&type=template&id=78c7563e&scoped=true&"
import script from "./Clothing.vue?vue&type=script&lang=js&"
export * from "./Clothing.vue?vue&type=script&lang=js&"
import style0 from "./Clothing.vue?vue&type=style&index=0&id=78c7563e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c7563e",
  null
  
)

export default component.exports